<template>
  <div>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="data"
      :items-per-page="per_page"
      :server-items-length="pagination.total"
    >
      <template v-slot:item.unit.name="{ item }">
        <a @click="goToUnit(item)" style="color: blue">
          {{ item.unit.name }}
        </a>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          :loading="loading.favorite"
          @click="unfavorite(item)"
          color="error"
        >
          Unfavorite
        </v-btn>
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | displayDateTime }}
      </template>
      <template v-slot:item.units="{ item }">
        {{ getUnitsCount(item.units) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'MyFavorites',
  props: {
    per_page: {
      default: 10,
    },
    icon_only: {
      default: false,
    },
  },
  data() {
    return {
      pagination: {
        current_page: 1,
        last_page: 2,
        items_per_page: 10,
        total: 10,
      },
      headers: [
        {
          text: 'Name',
          value: 'unit.name',
        },
        {
          text: 'Date Created',
          value: 'created_at',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ],
      loading: {
        table: true,
        favorite: false,
      },
      data: [],
    };
  },
  created() {
    this.getContents();
  },
  methods: {
    goToUnit(item) {
      this.$router.push({
        name: 'UnitPage',
        params: {
          id: item.unit.id,
        },
      });
    },
    unfavorite(item) {
      this.loading.favorite = true;
      this.$http
        .post('/unit/favorite', {
          unit_id: item.unit_id,
        })
        .then(() => {
          this.loading.favorite = false;
          this.pagination.current_page = 1;
          this.getContents();

          this.$notify(
            'success',
            'Successfully removed the unit from your favorites'
          );
        });
    },
    getUnitsCount(units) {
      return units.length;
    },
    getContents() {
      this.loading.table = true;
      this.$http('client/lms/assigned-and-shared-contents/favorites', {
        params: {
          page: this.pagination.current_page,
          per_page: this.per_page,
        },
      }).then(({ data }) => {
        this.data = data.data;
        this.pagination.last_page = data.last_page;
        this.pagination.total = data.total;
        this.loading.table = false;
      });
    },
  },
};
</script>

<style scoped></style>
